import * as types from '../types'
import { getDict, getHotPort } from '@/api/model/gen'
// import { QueryParams } from '@/hiti/QueryParam'
export default {
  state: {
    lineArea: [],
    hotPortList: [],
    linePort: []
  },

  getters: {
    lineArea: state => {
      return state.lineArea
    },
    hotPortList: state => {
      return state.hotPortList
    },
    linePort: state => {
      return state.linePort
    }
  },
  mutations: {
    setLineArea(state, data) {
      if (data) {
        state.lineArea = data
      }
    },
    setHotPort(state, data) {
      if (data) {
        state.hotPortList = data
      }
    },
    getLinePort(state, area) {
      state.lineArea.forEach(e => {
        if (e.code === area.code) {
          e.hover = true
        } else {
          e.hover = false
        }
      })
      state.linePort = []
      state.hotPortList.forEach(e => {
        if (e.lineAreaCode === area.code) {
          state.linePort.push(e)
        }
      })
    }
  },
  actions: {
    // [types.GET_LINEAREA]({ commit, state }) {
    //   if (state.lineArea.length <= 0) {
    //     const queryParam = new QueryParams()
    //     queryParam.add('dityCode', 'LINE_AREA')
    //     getDict({
    //       queryParam: queryParam.getQueryParams()
    //     }).then(data => {
    //       commit('setLineArea', data)
    //     })
    //   }
    // },
    [types.GET_HOTPORT]({ commit, state }) {
      // const queryParam = new QueryParams()
      // queryParam.add('dityCode', 'LINE_AREA')
      var getLine = getDict({
        // ...queryParam.getQueryParams()
        queryMap: {'dityCode': 'LINE_AREA'}
      })

      // const queryParam2 = new QueryParams()
      // queryParam2.add('hotPortFlag', 1)
      var getport = getHotPort({
        // ...queryParam2.getQueryParams()
        queryMap: {'hotPortFlag': 1}
      })
      Promise.all([getLine, getport]).then((data) => {
        // console.log(data)
        commit('setLineArea', data[0])
        commit('setHotPort', data[1])
        commit('getLinePort', data[0][0])
      })
      // if (state.hotPortList.length <= 0) {
      //   getHotPort({
      //     sort: 'DESC',
      //     hotPortFlag: 1,
      //     blockCompCode: 1
      //   }).then(data => {
      //     commit('setHotPort', data)
      //   })
      // }
    }
  }
}
